import {jsx as _jsx} from "react/jsx-runtime";import * as React from 'react'
import ConnectButton from './ConnectButton'
import ProviderRowBase, {} from './ProviderRowBase'









const ProviderRow = (props) => {
  const {onConnectClick, submitting, ...other} = props

  const connectButton = _jsx(ConnectButton, { onConnectClick: onConnectClick, submitting: submitting,} )

  return _jsx(ProviderRowBase, { ...other, connectButton: connectButton,} )
}

export default ProviderRow
